<template>
  <div class="form-card">
      <div class="form-group">
        <label>Select Industry:</label>
        <select v-model="selectedIndustry" @change="updateHBAValues">
          <option disabled value="">-- Select Industry --</option>
          <option value="cem">Cement/Fertilizer</option>
          <option value="cus">Custom (Assumption)</option>
          <option value="exp">Export/Industry (Non PLN/Cement/Fertilizer)</option>
          <option value="pln">PLN/IPP</option>
          <option value="p40">PLN IPP TM >40%</option>
        </select>
      </div>

      <div v-if="selectedIndustry!=='cus'" class="form-group">
        <label>Select Period:</label>
        <select v-model="selectedPeriod" @change="updateHBAValues">
          <option disabled value="">-- Select Period --</option>
          <option value="F">15-APR-2026</option>
          <option value="E">01-APR-2026</option>
          <option value="D">15-MAR-2026</option>
          <option value="C">01-MAR-2026</option>
          <option value="B">15-FEB-2026</option>
          <option value="A">01-FEB-2026</option>
        </select>
      </div>
      <div v-if="selectedIndustry!=='cus'" class="hba-row">
        <span v-if="this.HBA0>0">HBA0: USD {{ HBA0 }}</span>
        <span v-if="this.HBA1>0">HBA1: USD {{ HBA1 }}</span>
        <span v-if="this.HBA2>0">HBA2: USD {{ HBA2 }}</span>
        <span v-if="this.HBA3>0">HBA3: USD {{ HBA3 }}</span>
      </div>

      <div v-if="selectedIndustry==='cus'" class="form-group">
        <label>HBA0:</label>
        <input type="number" v-model.number="HBA0" :step="0.01" :min="1.00" :max="1000.00"/>
      </div>
       <div v-if="selectedIndustry==='cus'" class="form-group">
        <label>HBA1:</label>
        <input type="number" v-model.number="HBA1" :step="0.01" :min="1.00" :max="1000.00"/>
      </div>
       <div v-if="selectedIndustry==='cus'" class="form-group">
        <label>HBA2:</label>
        <input type="number" v-model.number="HBA2" :step="0.01" :min="1.00" :max="1000.00"/>
      </div>
       <div v-if="selectedIndustry==='cus'" class="form-group">
        <label>HBA3:</label>
        <input type="number" v-model.number="HBA3" :step="0.01" :min="1.00" :max="1000.00"/>
      </div>

      <div class="form-group">
        <label>GCV (ARB):</label>
        <input type="number" v-model.number="k" :step="10" :min="3000" :max="7000"/>
      </div>
      <div class="form-group">
        <label>Total Moisture (ARB):</label>
        <input type="number" v-model.number="tm" :step="1" :min="1" :max="100"/>
      </div>
      <div class="form-group">
        <label>Total Sulphur (ARB):</label>
        <input type="number" v-model.number="ts" :step="0.01" :min="0.00" :max="100.00"/>
      </div>
      <div class="form-group">
        <label>Ash Content (ARB):</label>
        <input type="number" v-model.number="ash" :step="0.01" :min="0.00" :max="100.00"/>
      </div>

      <button class="calculate-button" @click="doCalculation">
        Calculate HPB
      </button>

      <div v-if="HPB !== null" class="result">
        <label>HPB Result: </label>
        <span>USD {{ HPB.toFixed(2) }}</span>
      </div>
    </div>
</template>
<script>
import { periodHBA } from "@/data/hba-values";
import { calculateHPB } from "@/utils/hpb-calculator";
export default {
  data() {
    return {
      selectedIndustry: '',
      selectedPeriod: '',
      HPB: null, 
      HBA0: null,
      HBA1: null,
      HBA2: null,
      HBA3: null,
      k: 5000,
      tm: 30,
      ts: 0.08,
      ash: 2.45
    };
  },
  methods: {
    updateHBAValues() {
      this.HPB = null;
      const hba = periodHBA[this.selectedPeriod];
      if (hba) {
        this.HBA0 = hba.HBA0;
        this.HBA1 = hba.HBA1;
        this.HBA2 = hba.HBA2;
        this.HBA3 = hba.HBA3;
      } 
      
      if (this.selectedIndustry === 'cem' && this.HBA0 > 90) {
        this.HBA0 = 90;
        this.HBA1 = this.HBA2 = this.HBA3 = 0;
      } else if (this.selectedIndustry === 'pln' || this.selectedIndustry === 'p40') {
        if (this.HBA0 > 70) {
          this.HBA0 = 70;
          this.HBA1 = this.HBA2 = this.HBA3 = 0;
        }
      } else if (this.selectedIndustry === 'cus') {
        this.selectedPeriod = 'F';
      }
    },
    doCalculation() {
      if (this.selectedIndustry === '') {
        alert('Please select a industry');
        return;
      }
      if (this.selectedPeriod === '') {
        alert('Please select a period');
        return;
      }
      if ([this.k, this.tm, this.ts, this.ash].some(val => val === null)) {
        alert('Please fill all input values');
        return;
      }

      const hba = {
        HBA0: this.HBA0,
        HBA1: this.HBA1,
        HBA2: this.HBA2,
        HBA3: this.HBA3
      };
      const result = calculateHPB(this.selectedIndustry, hba, this.k, this.tm, this.ts, this.ash);
      if (result !== null) {
        this.HPB = result;
      } else {
        alert("Kalori too low to calculate HPB");
        this.HPB = null;
      }
    }
  }
};
</script>
<style scoped>
.form-card {
  width: 100%;
  max-width: 600px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

.form-card h2 {
  margin-bottom: 20px;
  text-align: center;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 5px;
}

.form-group input,
.form-group select {
  padding: 6px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.hba-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 20px;
}

.calculate-button {
  width: 100%;
  padding: 12px;
  background-color: #007ACC;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
}

.calculate-button:hover {
  background-color: #005fa3;
}

.result {
  margin-top: 20px;
  padding: 20px;
  background-color: #2d2c2c;   /* Black background */
  color: #fff;                 /* White text */
  border-radius: 10px;
  border: 1px solid #333;
  text-align: center;            /* Center text horizontally */
  display: flex;
  flex-direction: column;        /* Stack label and span vertically */
  align-items: center;           /* Center items horizontally */
  justify-content: center;       /* Center vertically if needed */
  font-size: 18px;
  gap: 8px;                      /* Space between label and value */
}

@media (max-width: 768px) {
  .form-card {
    padding: 15px;
  }

  .form-group label {
    font-size: 14px;
  }

  .form-group input,
  .form-group select {
    font-size: 14px;
    padding: 10px;
  }
}
</style>